import LockTableRow from "./LockTableRow";
import InactiveCellRenderer from "../renderers/InactiveCellRenderer";

export default class InactiveRow extends LockTableRow {
    constructor() {
        super();
        this.groupCell = document.createElement("td");
        this.groupCell.innerHTML = "&nbsp;";
        this.getRowEl().appendChild(this.groupCell);

        this.inactiveRenderer = new InactiveCellRenderer();
    }

    createRowHeaderRenderer() {
        return this.inactiveRenderer;
    }

    createLockCellRenderer() {
        return this.inactiveRenderer;
    }

    accept(visitor, cell) {
        return visitor.visitInactiveRow(cell);
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/InactiveRow.js